import React, { Component } from 'react';
import { connect } from 'react-redux';

import { update_filter } from '../../../actions/update_state';

import HomeVideo from './HomeVideo';
import Calendar from './Calendar';
import Shop from './Shop';
import SEO from '../../Common/SEO';

import './style.css';

export class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fade: true,
    }
  }

  componentDidMount() {
    // проявление страницы
    setTimeout(() => {
        this.setState({
            fade: false
        })
    }, 1000);
  }

  _filter_click(e) {
    this.props.update_filter(e.target.attributes.filter.nodeValue);
  }

  render() {
        return(
            <main className={this.state.fade === true ? 'main-home' : 'main-home main-home_fadeIn'}>
                <SEO title={'Главная страница'} />
                <div>
                    <HomeVideo />
                </div>
                <div className="lg-container">
                    <Calendar />
                    <Shop />
                </div>
            </main>
        )
  }
}

const mapStateToProps = (state) => ({
  home_filter_value: state.home_filter_value
})

const mapDispatchToProps = (dispatch) => ({
  update_filter: (text) => dispatch(update_filter(text))
})

export default connect(mapStateToProps, mapDispatchToProps)(Main);